import { Auth, HttpDriver } from "vue-auth3";
import { ArrayWrap } from "@/mixins";

type OptionRequest = {
  data?: Parameters<HttpDriver["request"]>[0]["data"];
  headers: Required<Parameters<HttpDriver["request"]>[0]>["headers"];
};

type AuthDriver = {
  tokens?: string[];
  request: (auth: Auth, options: OptionRequest, token: string) => OptionRequest;
  response: (auth: Auth, response: Awaited<ReturnType<HttpDriver["request"]>>) => string | null;
};

interface Token {
  aud: string;
  country: string;
  metro_id: string;
  realm: string;
  userType: string;
  exp: number;
  email: string;
  authorization: ArrayWrap<ArrayWrap<any>[]>[];
}
export { Token };

export default AuthDriver;
export function defineAuthDriver(opts: AuthDriver) {
  return opts;
}
